/**
 * Who raised each of the app-level modal flags.
 *
 * `openAskBuyin` and friends live in the GlobalContext mounted at the app root
 * (index.tsx), so they are ONE value for the whole app. contexts/TableGlobalScope
 * gives each table panel its own copy, and this registry records which table a
 * value came from so the copies stay independent without losing writes that
 * arrive from outside every panel:
 *
 * - a table's own gameID — that table raised it; no other table may adopt it.
 * - `null` (nothing claimed) — it was raised from outside any panel: App.tsx's
 *   socket handlers, the lobby. It is meant for whichever table the player is
 *   on, so that table adopts it.
 */

const owners = new Map<string, string>();

/** Record that `gameID`'s panel raised `field`. */
export const claimGlobalModal = (field: string, gameID: string): void => {
  if (gameID) owners.set(field, gameID);
};

/** Drop the claim on `field` (its modal closed, or its table went away). */
export const releaseGlobalModal = (field: string): void => {
  owners.delete(field);
};

/** The gameID that raised `field`, or null when nothing has claimed it. */
export const globalModalOwner = (field: string): string | null => owners.get(field) ?? null;

/** Test-only reset. */
export const __resetGlobalModalScope = (): void => {
  owners.clear();
};
